import { ICategory } from "../models/categoryModel";
import { categories } from "../repositories/";
import _ from "lodash";

export default {
  getCategories: async (
    query: any,
    callback: (data?: ICategory[], err?: any) => void
  ) => {
    let result: ICategory[] = [];
    try {
      let _query = {
        is_field: "img name long_name name_alias is_show_home keywords",
      };
      _query = _.extend(_query, query);
      const rs = await categories.getCategories(_query);
      result = rs.data;

      callback(rs.data, null);
    } catch (error) {
      callback(result, error);
    }
  },
  getMenuCategories: async (
    info: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await categories.getMenuCategories(info);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
  getBannersCategory: async (
    info: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await categories.getBannersCategory(info);
      callback(rs.data, null);
    } catch (error) {
      callback(null, error);
    }
  },
};
